import { Component, OnInit } from "@angular/core";
import { ResetPasswordRequestForm } from "./reset-password-request-form";
import { ResetPasswordRequestRequest } from "./reset-password-request-request";
import { AuthenticationService } from "../shared/authentication/authentication.service";
import { NotificationService } from "../../notification/shared/notification.service";
import { HttpResponse } from "@angular/common/http";

@Component({
  selector: "app-reset-password-request",
  templateUrl: "./reset-password-request.component.html",
  styleUrls: ["./../shared/user.scss", "./reset-password-request.component.scss", './../login/login.component.scss']
})
export class ResetPasswordRequestComponent implements OnInit {
  form: ResetPasswordRequestForm;
  error: string | object = null;

  constructor(
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService) { }

  private prepareRequest(): ResetPasswordRequestRequest {
    return new ResetPasswordRequestRequest(this.form.get("username").value);
  }

  private succeedResetRequest(message: HttpResponse<string>) {
    this.notificationService.notif(message.body, "notif");
  }

  private failedResetRequest(error: any) {
    this.error = error.error;
  }

  ngOnInit() {
    this.form = new ResetPasswordRequestForm();
    this.form.statusChanges.subscribe(event => this.clearError());
  }

  private clearError() {
    this.error = null;
  }

  public submit() {
    if (this.form.valid) {
      let request: ResetPasswordRequestRequest = this.prepareRequest();
      this.authenticationService
        .requestPasswordReset(request)
        .subscribe(
          respons => this.succeedResetRequest(respons),
          error => this.failedResetRequest(error)
        );
    }
  }
}
